import {
    GET_NA_COURT_CONFIG_DATA,
    GET_NA_COURT_CONFIG_DATA_SUCCESS,
    GET_NA_COURT_CONFIG_DATA_FAILURE,
    GET_NA_DEFAULT_COURT_CONFIG_DATA,
    GET_NA_DEFAULT_COURT_CONFIG_DATA_SUCCESS,
    GET_NA_DEFAULT_COURT_CONFIG_DATA_FAILURE,
    SAVE_NA_COURT_CONFIG_DATA,
    SAVE_NA_COURT_CONFIG_DATA_SUCCESS,
    SAVE_NA_COURT_CONFIG_DATA_FAILURE,
    UPDATE_NA_FACILITIES_BASED_ON_CONFIG,
    UPDATE_NA_SHOW_CONFIG_MODAL,
    UPDATE_NA_SELECTED_FACILITY,
    UPDATE_NA_SIDE_BAR_DISPLAY_TYPE,
    UPDATE_NA_SIDE_BAR_STATUS_TYPE,
    CLEAR_NEXT_AVAILABLE_DATA,
    TOGGLE_NA_ADD_DRAWS_SIDE_PANEL,
    SAVE_NA_DRAWS_TO_SCHEDULE,
    SAVE_NA_DRAWS_TO_SCHEDULE_SUCCESS,
    SAVE_NA_DRAWS_TO_SCHEDULE_FAILURE,
    GET_NA_DRAWS_SCHEDULED,
    GET_NA_DRAWS_SCHEDULED_SUCCESS,
    GET_NA_DRAWS_SCHEDULED_FAILURE,
    UPDATE_NA_SUMMARY,
    GET_NA_NOT_ON_COURT_MATCHES,
    GET_NA_NOT_ON_COURT_MATCHES_SUCCESS,
    GET_NA_NOT_ON_COURT_MATCHES_FAILURE,
    CLEAR_NA_CONFIG_AND_FACILITY_SPECIFIC_DATA,
    UPDATE_NA_NOT_ON_COURT_MATCHES,
    UPDATE_NA_ON_COURT_MATCHES,
    GET_NA_ON_COURT_MATCHES_SUCCESS,
    GET_NA_ON_COURT_MATCHES_FAILURE,
    GET_NA_ON_COURT_MATCHES,
    SHOW_MATCH_STARTED_MODAL,
    NA_POST_SCORE,
    NA_POST_SCORE_SUCCESS,
    NA_POST_SCORE_FAILURE,
    SET_NA_ACTION_CONFIRM_POPUP_DATA,
    NA_POST_SCORE_CLEAR,
    NA_PUBLISH_DRAWS,
    NA_PUBLISH_DRAWS_SUCCESS,
    NA_PUBLISH_DRAWS_FAILURE,
    NA_CLEAR_PUBLISH_STATUS,
    CLEAR_NA_DRAWS_NOTIFICATIONS,
} from '../actions/actionTypes/next-available-types';
import { DrawStatusTypes, SideBarDisplayTypes } from '../utils/nextAvailable';

const initialState = {
    isLoadingConfig: false,
    defaultCourtConfig: null,
    selectedDate: null,
    selectedDateCourtConfig: null,
    facilitiesAvailable: [],
    selectedFacilityId: '',
    isSavingConfig: false,
    showConfigModal: false,
    sidebar: {
        displayType: SideBarDisplayTypes.DRAWS,
        statusType: DrawStatusTypes.TODO,
        isLoadingDraws: false,
        isLoadingMatches: false,
    },
    showAddDrawsSidePanel: false,
    isAddingDraws: false,
    draws: [],
    drawStatusChangesToNotify: {
        drawCompletedNotifications: [],
        drawReadyToStartNotifications: [],
        drawsToBeAutoFilledNotifications: [],
    },
    summary: {
        draws: 0,
        matches: 0,
        matchesTodo: 0,
        matchesInQueue: 0,
        matchesOnCourt: 0,
        matchesDone: 0,
    },
    onCourtMatches: [],
    notOnCourtMatches: {},
    matchStartedModal: {
        show: false,
        match: null,
    },
    postScore: {
        isSaving: false,
        error: null,
        success: false,
    },
    actionConfirmPopup: {
        show: false,
        type: null,
        data: null,
    },
    publishStatus: {
        isPublishing: false,
        isPublishSuccess: false,
        isPublishFailed: false,
    },
};

function nextAvailableReducer(state = initialState, action) {
    switch (action.type) {
        case GET_NA_COURT_CONFIG_DATA:
            return {
                ...state,
                isLoadingConfig: true,
                selectedDate: action.payload.selectedDate,
                selectedDateCourtConfig: null,
            };
        case GET_NA_COURT_CONFIG_DATA_SUCCESS:
            return {
                ...state,
                isLoadingConfig: false,
                selectedDateCourtConfig: action.payload.courtConfig,
            };
        case GET_NA_COURT_CONFIG_DATA_FAILURE:
            return {
                ...state,
                isLoadingConfig: false,
                selectedDateCourtConfig: null,
            };
        case GET_NA_DEFAULT_COURT_CONFIG_DATA:
            return {
                ...state,
                isLoadingConfig: true,
                defaultCourtConfig: null,
            };
        case GET_NA_DEFAULT_COURT_CONFIG_DATA_SUCCESS:
            return {
                ...state,
                isLoadingConfig: false,
                defaultCourtConfig: action.payload.courtConfig,
            };
        case GET_NA_DEFAULT_COURT_CONFIG_DATA_FAILURE:
            return {
                ...state,
                isLoadingConfig: false,
                defaultCourtConfig: null,
            };
        case UPDATE_NA_FACILITIES_BASED_ON_CONFIG:
            return {
                ...state,
                facilitiesAvailable: action.payload.facilitiesAvailable,
            };
        case UPDATE_NA_SELECTED_FACILITY:
            return {
                ...state,
                selectedFacilityId: action.payload.facilityId,
                courtsOfSelectedFacility: action.payload.courtsOfSelectedFacility,
            };
        case SAVE_NA_COURT_CONFIG_DATA:
            return {
                ...state,
                isSavingConfig: true,
            };
        case SAVE_NA_COURT_CONFIG_DATA_SUCCESS:
        case SAVE_NA_COURT_CONFIG_DATA_FAILURE:
            return {
                ...state,
                isSavingConfig: false,
            };
        case UPDATE_NA_SHOW_CONFIG_MODAL:
            return {
                ...state,
                showConfigModal: action.payload.showConfigModal,
            };
        case UPDATE_NA_SIDE_BAR_DISPLAY_TYPE:
            return {
                ...state,
                sidebar: {
                    ...(state.sidebar),
                    displayType: action.payload.displayType,
                    statusType: action.payload.statusType,
                    isLoadingDraws: false,
                },
            };
        case UPDATE_NA_SIDE_BAR_STATUS_TYPE:
            return {
                ...state,
                sidebar: {
                    ...(state.sidebar),
                    statusType: action.payload.statusType,
                    isLoadingDraws: false,
                },
            };
        case CLEAR_NEXT_AVAILABLE_DATA:
            return initialState;
        case TOGGLE_NA_ADD_DRAWS_SIDE_PANEL:
            return {
                ...state,
                showAddDrawsSidePanel: !state.showAddDrawsSidePanel,
            };
        case SAVE_NA_DRAWS_TO_SCHEDULE:
            return {
                ...state,
                isAddingDraws: true,
            };
        case SAVE_NA_DRAWS_TO_SCHEDULE_SUCCESS:
        case SAVE_NA_DRAWS_TO_SCHEDULE_FAILURE:
            return {
                ...state,
                isAddingDraws: false,
            };
        case GET_NA_DRAWS_SCHEDULED:
            return {
                ...state,
                sidebar: {
                    ...(state.sidebar),
                    isLoadingDraws: true,
                },
            };
        case GET_NA_DRAWS_SCHEDULED_SUCCESS:
            return {
                ...state,
                sidebar: {
                    ...(state.sidebar),
                    isLoadingDraws: false,
                },
                draws: action.payload.draws,
                drawStatusChangesToNotify: action.payload.drawStatusChangesToNotify,
            };
        case GET_NA_DRAWS_SCHEDULED_FAILURE:
            return {
                ...state,
                sidebar: {
                    ...(state.sidebar),
                    isLoadingDraws: false,
                },
                draws: [],
                drawStatusChangesToNotify: {},
            };
        case CLEAR_NA_DRAWS_NOTIFICATIONS:
            return {
                ...state,
                drawStatusChangesToNotify: initialState.drawStatusChangesToNotify,
            };
        case UPDATE_NA_SUMMARY:
            return {
                ...state,
                summary: action.payload.summary,
            };
        case GET_NA_NOT_ON_COURT_MATCHES:
            return {
                ...state,
                sidebar: {
                    ...(state.sidebar),
                    isLoadingMatches: true,
                },
                notOnCourtMatches: {},
            };
        case GET_NA_NOT_ON_COURT_MATCHES_SUCCESS:
            return {
                ...state,
                sidebar: {
                    ...(state.sidebar),
                    isLoadingMatches: false,
                },
                notOnCourtMatches: action.payload.matches,
            };
        case GET_NA_NOT_ON_COURT_MATCHES_FAILURE:
            return {
                ...state,
                sidebar: {
                    ...(state.sidebar),
                    isLoadingMatches: false,
                },
                notOnCourtMatches: {},
            };
        case CLEAR_NA_CONFIG_AND_FACILITY_SPECIFIC_DATA:
            return {
                ...state,
                sidebar: initialState.sidebar,
                draws: initialState.draws,
                drawStatusChangesToNotify: initialState.drawStatusChangesToNotify,
                summary: initialState.summary,
                onCourtMatches: initialState.onCourtMatches,
                notOnCourtMatches: initialState.notOnCourtMatches,
            };
        case UPDATE_NA_NOT_ON_COURT_MATCHES:
            return {
                ...state,
                notOnCourtMatches: action.payload.matches,
            };
        case UPDATE_NA_ON_COURT_MATCHES:
        case GET_NA_ON_COURT_MATCHES:
        case GET_NA_ON_COURT_MATCHES_SUCCESS:
            return {
                ...state,
                onCourtMatches: action.payload.matches,
            };
        case GET_NA_ON_COURT_MATCHES_FAILURE:
            return {
                ...state,
                onCourtMatches: [],
            };
        case SHOW_MATCH_STARTED_MODAL:
            return {
                ...state,
                matchStartedModal: {
                    show: action.payload.show,
                    match: action.payload.match,
                },
            };
        case NA_POST_SCORE:
            return {
                ...state,
                postScore: {
                    isSaving: true,
                    error: null,
                    success: false,
                },
            };
        case NA_POST_SCORE_SUCCESS:
            return {
                ...state,
                postScore: {
                    isSaving: false,
                    error: null,
                    success: true,
                },
            };
        case NA_POST_SCORE_FAILURE:
            return {
                ...state,
                postScore: {
                    isSaving: false,
                    error: action.payload,
                    success: false,
                },
            };
        case NA_POST_SCORE_CLEAR:
            return {
                ...state,
                postScore: {
                    isSaving: false,
                    error: null,
                    success: false,
                },
            };
        case SET_NA_ACTION_CONFIRM_POPUP_DATA:
            return {
                ...state,
                actionConfirmPopup: {
                    show: action.payload.show,
                    type: action.payload.type,
                    data: action.payload.data,
                },
            };
        case NA_PUBLISH_DRAWS:
            return {
                ...state,
                publishStatus: {
                    isPublishing: true,
                    isPublishSuccess: false,
                    isPublishFailed: false,
                },
            };
        case NA_PUBLISH_DRAWS_SUCCESS:
            return {
                ...state,
                publishStatus: {
                    isPublishing: false,
                    isPublishSuccess: true,
                    isPublishFailed: false,
                },
            };
        case NA_PUBLISH_DRAWS_FAILURE:
            return {
                ...state,
                publishStatus: {
                    isPublishing: false,
                    isPublishSuccess: false,
                    isPublishFailed: true,
                },
            };
        case NA_CLEAR_PUBLISH_STATUS:
            return {
                ...state,
                publishStatus: {
                    isPublishing: false,
                    isPublishSuccess: false,
                    isPublishFailed: false,
                },
            };
        default:
            return state;
    }
}

export default nextAvailableReducer;
